/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnitType } from '@src/app/model/unit-type';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
@Injectable({
  providedIn: 'root'
})
export class UnitCategoryService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected typeString = 'UnitCategory';
  protected get baseUrl(): string {
      return this.getAjaxPath('units/categories');
  }
  protected cache: UnitType[] = [];
}
